import axiosIS from "@/api/net/axios.js";
import ApiConfig, { baseUrl } from "@/config/apiConfig.js";
import grobalConfig from "@/config/config.js";

const EMAIL_PASSWORD_DEVICE_ID_KEY = "mureka_email_password_device_id";

const createDeviceId = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const getEmailPasswordDeviceId = () => {
  let deviceId = localStorage.getItem(EMAIL_PASSWORD_DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = createDeviceId();
    localStorage.setItem(EMAIL_PASSWORD_DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};

const buildQuery = (data = {}) => {
  const params = new URLSearchParams();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });
  const query = params.toString();
  return query ? `?${query}` : "";
};

const emailPasswordApiBase = import.meta.env.DEV ? "" : baseUrl;

const buildEmailPasswordApiUrl = (path, data = {}) => {
  return `${emailPasswordApiBase}${path}${buildQuery(data)}`;
};

const normalizeErrResponse = (res) => {
  if (!res) return res;

  if (res.code === 0 || res.code === "0") {
    return {
      ...res,
      code: 200,
    };
  }

  if (res.code !== undefined) return res;

  const err = res.err || res.data?.err;
  if (!err) return res;

  const errCode = Number(err.code ?? err.err_code ?? 0);
  return {
    ...res,
    code: errCode === 0 ? 200 : errCode,
    msg: err.msg || err.message || "",
    data: res.data || res,
  };
};

const requestEmailApi = (...args) => {
  return axiosIS(...args).then(normalizeErrResponse);
};

export default {
  // SVC-邮箱登录(三方注册登录)
  // https://rg975ojk5z.feishu.cn/docx/Yrgrd964roO1cDxHgz8cc4HcnBh
  userLogin(data = {}) {
    return axiosIS(`${baseUrl}${ApiConfig.loginIn}`, data, { method: "post" });
  },
  async emailPasswordLogin(data = {}) {
    return requestEmailApi(
      `${emailPasswordApiBase}/api/user/email/login`,
      {
        mode: "otp_email",
        device_id: getEmailPasswordDeviceId(),
        source: "",
        ...data,
      },
      {
        method: "post",
        validateStatus: (status) => status >= 200 && status < 500,
      }
    );
  },
  async requestEmailVerification(data = {}) {
    return requestEmailApi(
      buildEmailPasswordApiUrl("/api/user/login/otp/email", {
        email: data.email,
        source: data.source,
      }),
      {},
      { method: "get" }
    );
  },
  getEmailVerifyUrl(data = {}) {
    return buildEmailPasswordApiUrl("/api/third/email/verify", {
      lang: data.lang,
      code: data.code,
    });
  },
  async verifyEmailLink(data = {}) {
    return requestEmailApi(
      this.getEmailVerifyUrl({
        lang: data.lang,
        code: data.code,
      }),
      {},
      { method: "get" }
    );
  },
  async setVerifiedEmailPassword(data = {}) {
    return requestEmailApi(
      `${emailPasswordApiBase}/api/user/email/set-password`,
      {
        token: data.token,
        password: data.password,
        meta: data.meta || {},
      },
      { method: "put" }
    );
  },
  async requestEmailPasswordReset(data = {}) {
    return requestEmailApi(
      `${emailPasswordApiBase}/api/user/password/lost`,
      {
        email: data.email,
        meta: data.meta || {},
      },
      { method: "post" }
    );
  },
  getPasswordResetVerifyUrl(data = {}) {
    return buildEmailPasswordApiUrl("/api/third/password/verify", {
      lang: data.lang,
      t: data.t || data.token,
    });
  },
  async verifyPasswordResetLink(data = {}) {
    return requestEmailApi(
      this.getPasswordResetVerifyUrl({
        lang: data.lang,
        t: data.t || data.token,
      }),
      {},
      { method: "get" }
    );
  },
  async resetEmailPassword(data = {}) {
    return requestEmailApi(
      `${emailPasswordApiBase}/api/user/password`,
      {
        token: data.token,
        password: data.password,
      },
      { method: "put" }
    );
  },
  userBind(data = {}) {
    return axiosIS(`${baseUrl}/api/user/bind`, data, { method: "post" });
  },
  // SVC-登出
  //   https://rg975ojk5z.feishu.cn/docx/DhN9d9zl1ojeryx2B6rcTay3ncd
  userLoginOut(data = {}, user_id) {
    return axiosIS(`${baseUrl}${ApiConfig.loginOut}/${user_id}`, data, {
      method: "post",
    });
  },
  // SVC-个人用户基本信息
  // https://rg975ojk5z.feishu.cn/docx/CZ9Wd29fRoxCVHxf6d9cbkrGnhc
  userGetInfo() {
    return axiosIS(
      `${baseUrl}${grobalConfig.appname == "YinFeng" ? ApiConfig.getUserInfoCn : ApiConfig.getUserInfo}`,
      {},
      { method: "get" }
    );
  },
  // 获取验证码
  getVerifyCode(data = {}) {
    return axiosIS(`${baseUrl}/api/user/login/otp/message`, data, {
      method: "post",
    });
  },
  getVerifyCodeV1(data = {}) {
    return axiosIS(`${baseUrl}/api/user/login/otp/message/v1`, data, {
      method: "post",
    });
  },
  userPaySuccess(data = {}) {
    return axiosIS(`${baseUrl}/api/payment/issue_report`, data, {
      method: "post",
    });
  },
};
